export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-60x60-3251a8ec8c06646f1bcd6b0ee70db965.png";